import { isLocationPageType } from '../../domain/useCases/pageTypeCheck'

export const shouldShowCoOccurringCenters = ({
  pageType = '',
  coOccurringDisordersCenters = [],
  hitCount
} = {}) => {
  const isLocationPageAndHasMoreThanFiveCoOccurringDisorderCenters =
    isLocationPageType(pageType) && coOccurringDisordersCenters?.length > 4

  if (hitCount) {
    return (
      isLocationPageAndHasMoreThanFiveCoOccurringDisorderCenters &&
      hitCount > 19
    )
  }

  return isLocationPageAndHasMoreThanFiveCoOccurringDisorderCenters
}
